import keyMirror from 'keymirror';

export const resultTabActionTypes = keyMirror({
	GET_RESULT_TAB_SUMMARY: null,
	GET_RESULT_TAB_SUMMARY_SUCCESS: null,
	GET_RESULT_TAB_SUMMARY_ERROR: null,

	GET_RESULT_TAB_RESULTS: null,
	GET_RESULT_TAB_RESULTS_SUCCESS: null,
	GET_RESULT_TAB_RESULTS_ERROR: null,
});
